<template>
    <b-card tag="div" class="shadow h-100 wl-card wl-card__product w-100" :class="[`bg-${variant}`, (noPadding) ? 'wl-card--no-padding' : 'p-2' ]">

    <div class="wl-card__product__image d-flex justify-content-center wl-card__product__image--full">

      <div v-if="badgeText && badgeText !== 'NONE'" class="wl-card__product__price-badge">
        <span v-if="isTranscriberIsInProgress">
          <span v-html="badgeText" class="elementToFadeInAndOut"></span>
        </span>
        <span v-else v-html="badgeText"></span>
        <!--<dumbBubbleAnimation fill-color="cta"/>-->
      </div>
      <b-img :src="productImage" v-if="productImage" fluid :alt="productTitle" @click="$emit('submit', { url: productCtaLink, type: productType, product: product})"/>
    </div>
    <b-container fluid="xxl" class="mb-1 mt-5">
        <b-row>
            <b-col cols="12">
                <div class="p-2 mt-3">
                    <h6 class="font-light">{{ getProductTypeDescription }}</h6>
                    <h5>{{ productTitle }}</h5>
                    <p v-html="htmlProductDescription" v-if="productDescription"></p>
                    <p><small>{{ productPurchased }}</small></p>
                </div>
               
            </b-col>
        </b-row>
        
    </b-container>
     <div class="d-flex justify-content-center mt-auto mb-5" v-if="productBtnLabel != ''">

        <b-button v-if="((productPseudoPrice == 0 && productPrice == 0) || productIsMyCourse) && !isTranscriberContent" @click="$emit('submit', { url: productCtaLink, type: productType, product: product})"  type="button" variant="cta" class="button-cta mt-4">
            {{ productBtnLabel }}
        </b-button>

       <b-button-group v-else-if="isTranscriberContent" class="mt-4">

         <b-button
             v-if="isTranscriberIsInProgress == 0 && isTranscriberWaitingForPayment == 0"
             @click="$emit('submit', { url: productCtaLink, type: productType, product: product})"  type="button" variant="cta" class="button-cta">
           {{ productBtnLabel }}
         </b-button>
         <b-button type="button" variant="cta-secondary" class="button-cta-secondary append" v-if="productPseudoPrice > 0">
           <span class="old-price small-text light-weight strike-through"><span v-html="$utils.formatPseudoPrice(productPseudoPrice)"></span></span>
           <span class="discount small-text">{{$t('PRICE_DISCOUNT', '', {discount: $utils.getPercent(productPseudoPrice, productPrice)})}}</span>
         </b-button>
       </b-button-group>

        <b-button-group v-else class="mt-4">

            <b-button @click="$emit('submit', { url: productCtaLink, type: productType, product: product})"  type="button" variant="cta" class="button-cta">
                {{ $t('BUY_LEARNING_CONTENT') }}
            </b-button>
            <b-button type="button" variant="cta-secondary" class="button-cta-secondary append" v-if="productPseudoPrice > 0">
                <span class="old-price small-text light-weight strike-through"><span v-html="$utils.formatPseudoPrice(productPseudoPrice)"></span></span>
                <span class="discount small-text">{{$t('PRICE_DISCOUNT', '', {discount: $utils.getPercent(productPseudoPrice, productPrice)})}}</span>
            </b-button>
        </b-button-group>
       
     
    
    </div>

    </b-card>
</template>


<script>
import hocCard from '@/components/hoc/hocCard';
//import dumbBubbleAnimation from '@/components/dumb/dumbBubbleAnimation';
import Vue from 'vue'

export default {
  name: "ProductCard",
  emits: ['submit'],
  mixins: [hocCard],
  components: {
    //dumbBubbleAnimation,
},
  props: {
    product:{
      type: Object,
      default: () => ({}),
    },
    productId:{
        type: String,
        default:''
    },
    productTitle: {
        type: String,
        default:''
    },
    productType: {
        type: String,
        default:''
    },
    productImage: {
        type: String,
        default:''
    },
    productPrice: {
        type: String,
        default:''
    },
    productPseudoPrice: {
        type: String,
        default:''
    },
    productAction: {
        type: String,
        default:''
    },
    productCtaLink:  {
        type: String,
        default:''
    },
    productBtnLabel: {
        type: String,
        default:''
    },
    productDescription: {
        type: String,
        default:''
    },
    productPurchased: {
      type: String,
      default:''
    },
    productIsMyCourse: {
      type: Number,
      default: 0
    },
    badgeText:  {
      type: String,
      default:''
    },
    id: {
        type: String,
        default: () => Vue.utils.generateRandomHash(10)
    },
    isTranscriberContent: {
      type: Number,
      default: 0
    },
    isTranscriberIsInProgress: {
      type: Number,
      default: 0
    },
    isTranscriberWaitingForPayment: {
      type: Number,
      default: 0
    },

  },
  computed: {
    htmlProductDescription() {
      const src = this.productDescription || '';
      if (!src) return '';
      const trimmed = src.trim();
      const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);

      if (!looksLikeHtml) {
        // Pure Markdown -> full block conversion with paragraphs
        return this.__mdBlocks(trimmed, true);
      }

      // Mixed HTML + potential Markdown: convert Markdown only in text segments
      const parts = src.split(/(<[^>]+>)/g);
      const converted = parts.map(part => {
        if (!part) return '';
        if (part.startsWith('<')) return part; // keep tags as-is
        // Convert markdown in text, but avoid wrapping in <p> to not break existing HTML
        return this.__mdBlocks(part, false);
      });
      return converted.join('');
    },
    getProductTypeDescription() {
      const p = this.product || {};
      // Support both shapes: { product_teaser, product_type } and { product: { product_teaser, product_type } }
      const core = p && p.product ? p.product : p;
      const teaser = core && core.product_teaser ? String(core.product_teaser).trim() : '';
      if (teaser !== '') {
        return teaser;
      }
      return (core && core.product_type) ? core.product_type : (this.productType || '');

    },
  },
  methods: {
    __mdBlocks(text, wrapParagraphs = true) {
      const src = text || '';
      if (!src) return '';
      // Trim only leading/trailing blank lines to keep inner structure
      const trimmed = src.replace(/^\n+|\n+$/g, '');
      const blocks = trimmed.split(/\n\s*\n|\n(?=\s{0,3}#{1,6}\s)/);
      const out = blocks.map(block => {
        const lines = block.split(/\n/);
        // Ordered list?
        if (lines.length > 0 && lines.every(l => /^\s*\d+\.\s+/.test(l))) {
          const items = lines.map(l => `<li>${this.__mdInline(l.replace(/^\s*\d+\.\s+/, ''))}</li>`).join('');
          return `<ol>${items}</ol>`;
        }
        // Unordered list?
        if (lines.length > 0 && lines.every(l => /^\s*[-*]\s+/.test(l))) {
          const items = lines.map(l => `<li>${this.__mdInline(l.replace(/^\s*[-*]\s+/, ''))}</li>`).join('');
          return `<ul>${items}</ul>`;
        }
        // Headings (# ...) — match at the start of the block's first line
        const firstLine = lines[0] || '';
        const headingMatch = firstLine.match(/^\s{0,3}(#{1,6})\s+(.+?)\s*#*\s*$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const text = this.__mdInline(headingMatch[2]);
          if (lines.length > 1) {
            const rest = lines.slice(1).join('\n');
            const restContent = this.__mdInline(rest).replace(/\n/g, '<br/>' );
            const restWrapped = wrapParagraphs ? `<p>${restContent}</p>` : restContent;
            return `<h${level}>${text}</h${level}>` + restWrapped;
          }
          return `<h${level}>${text}</h${level}>`;
        }
        // Paragraph or raw text with preserved line breaks
        const content = this.__mdInline(lines.join('\n')).replace(/\n/g, '<br/>' );
        return wrapParagraphs ? `<p>${content}</p>` : content;
      });
      return out.join('');
    },
    __mdInline(text) {
      let html = text || '';
      // Links [text](https://url)
      html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      // Bold **text** or __text__
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');
      // Italic *text* or _text_
      html = html.replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, '$1<em>$2</em>');
      html = html.replace(/(^|[^_])_([^_]+)_(?!_)/g, '$1<em>$2</em>');
      return html;
    },
  }
}
</script>

<style>

.elementToFadeInAndOut {
  animation: fadeInOut 4s linear infinite forwards;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>

<style>
/* ProductCard: links inherit color, are underlined; hover removes underline */
.wl-card__product a,
.wl-card__product a:visited,
.wl-card__product a:active {
  color: inherit;
  text-decoration: underline;
  font-weight: bold;
}
.wl-card__product a:hover {
  color: inherit;
  text-decoration: none;
}
</style>
